import device from 'current-device';

const isTouchDevice = (): boolean => {
  return !device.desktop();
};

export default isTouchDevice;
